var headerHeight = $("#shopify-section-header").height();
$(window).scroll(function() {
scroll = $(window).scrollTop();
  if (scroll >= 1) {
    $(".both-headers").addClass("sticky-nav");
    $('main').css("padding-top", headerHeight);
    $('.free-shipping').slideUp('slow');
  } else {
    $(".both-headers").removeClass("sticky-nav");
    $('main').css("padding-top", 0);
    $('.free-shipping').slideDown('slow');
  }
});

$(window).scroll(function () {
  if(window.screen.width > 767) {
    $('.main-div .slick-current+.slick-active .homiah-slider-images').each(function () {
      if (isScrolledIntoView(this) === true) {
        $('.main-div .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').removeClass('flavour-scroll-outview');
        $('.main-div .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-inview');
      }
      else {
        $('.main-div .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').removeClass('flavour-scroll-inview');
        // $('.main-div .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-outview');
      }
  });
  }
  else {
    $('.main-div .slick-current .homiah-slider-images').each(function () {
      if (isScrolledIntoView(this) === true) {
        $('.main-div .homiah-flavours-section .slick-current .homiah-slider-images').removeClass('flavour-scroll-outview');
        $('.main-div .homiah-flavours-section .slick-current .homiah-slider-images').addClass('flavour-scroll-inview');
      }
      else {
        $('.main-div .homiah-flavours-section .slick-current .homiah-slider-images').removeClass('flavour-scroll-inview');
        // $('.main-div .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-outview');
      }
  });
  }
});

$(window).scroll(function () {
  if(window.screen.width > 767) {
    $('.pdp-main-div .homiah-slider-images').each(function () {
      if (isScrolledIntoView(this) === true) {
        $('.pdp-main-div .flavour-section-flavourList  .homiah-slider-images').removeClass('flavour-scroll-outview');
        $('.pdp-main-div .flavour-section-flavourList  .homiah-slider-images').addClass('flavour-scroll-inview');
      }
      else {
        $('.pdp-main-div .flavour-section-flavourList  .homiah-slider-images').removeClass('flavour-scroll-inview');
      }
    });
  }
});

$(".homiah-flavours-section-slider").on("beforeChange", function (){
  if(window.screen.width > 767) {
  setTimeout(() => {
  $(".main-div .homiah-flavours-section .slick-current").find(".flavour-scroll-inview").removeClass("flavour-scroll-inview");
  $(".main-div .homiah-flavours-section .homiah-flavours-section-slider .homiah-flavours-section-slider-content").find(".flavour-scroll-inview").removeClass("flavour-scroll-inview");
  $('.main-div .slick-current+.slick-active .homiah-slider-images').each(function () {
    if (isScrolledIntoView(this) === true) {
      // console.log("first");
      $('.main-div .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').removeClass('flavour-scroll-outview');
      $('.main-div  .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-inview');
    }
    else {
      $('.main-div .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').removeClass('flavour-scroll-inview');
      // $('.main-div .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-outview');
    }
  });  
  }, 0);
  }
  else {
    setTimeout(() => {
      $(".main-div .homiah-flavours-section .slick-current").find(".flavour-scroll-inview").removeClass("flavour-scroll-inview");
      $(".main-div .homiah-flavours-section .homiah-flavours-section-slider .homiah-flavours-section-slider-content").find(".flavour-scroll-inview").removeClass("flavour-scroll-inview");
      $('.main-div .slick-current .homiah-slider-images').each(function () {
        if (isScrolledIntoView(this) === true) {
          // console.log("first");
          $('.main-div .homiah-flavours-section .slick-current .homiah-slider-images').removeClass('flavour-scroll-outview');
          $('.main-div  .homiah-flavours-section .slick-current .homiah-slider-images').addClass('flavour-scroll-inview');
        }
        else {
          $('.main-div .homiah-flavours-section .slick-current .homiah-slider-images').removeClass('flavour-scroll-inview');
          // $('.main-div .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-outview');
        }
      });  
      }, 0);
  }
});

$(".flavour-section-flavourList").on("beforeChange", function (){
  if(window.screen.width > 767) {
  setTimeout(() => {
    $(".pdp-main-div .flavour-section-flavourList  .slick-current").find(".flavour-scroll-inview").removeClass("flavour-scroll-inview");
    $(".pdp-main-div .flavour-section-flavourList  .homiah-flavours-section-slider .homiah-flavours-section-slider-content").find(".flavour-scroll-inview").removeClass("flavour-scroll-inview");
    $('.pdp-main-div .slick-current .homiah-slider-images').each(function () {
      if (isScrolledIntoView(this) === true) {
        // console.log("first");
        $('.pdp-main-div .flavour-section-flavourList .homiah-slider-images').removeClass('flavour-scroll-inview');
        $('.pdp-main-div  .flavour-section-flavourList .slick-current .homiah-slider-images').addClass('flavour-scroll-inview');
      }
      else {
        $('.pdp-main-div .flavour-section-flavourList  .slick-current .homiah-slider-images').removeClass('flavour-scroll-inview');
        // $('.pdp-main-div .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-outview');
      }
    });  
    }, 0);
  }
});
function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

//Switching between the headers on PDP
let disappearingPoint=  $('.flavour-section-text').offset();
let HeightOfHeaders = $(".visibility-of-headers").height();
var windowWidth = $(document).width();
let stopVisibilityDown = function () {
  if(window.location.href.indexOf("products")!=-1 ){
  let scroll = window.pageYOffset || document.documentElement.scrollTop; 
  // // console.log("scroll",scroll);
   if (scroll > 550 && windowWidth >600){
    $('.visibility-of-headers.toggleHeaders').slideUp("fast");  

      $('.sticky-header').css({'display':'flex','margin-top':'0',}); 
   } 
   else if(scroll<550 && windowWidth>600) {
    $('.visibility-of-headers.toggleHeaders').slideDown("fast"); 
    $('.sticky-header').hide();
     }
     else if (scroll<disappearingPoint && windowWidth>600){
      $('.visibility-of-headers.toggleHeaders').show();
      $('.sticky-header').css({'display':'flex','margin-top':HeightOfHeaders+'px',});
     }
     else if (scroll>550 && windowWidth<=600){
      $('.visibility-of-headers').show(); 
      $('.visibility-of-headers').removeClass('toggleHeaders'); 
      $('.sticky-header').css({'display':'flex','bottom':'0','top':'auto',}); 
     }
     else if (scroll<550 && windowWidth<=600){
      $('.sticky-header').hide()
     }
     
    disappearingPoint = scroll;
  }
};
window.addEventListener("scroll", stopVisibilityDown);

function copyToClipboard(element) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
}

let checkExist = setInterval(function() {
  let elem = $('[data-testid="POPUP"] form button').text()
  if(elem === 'COPY CODE'){
    let copyElem = $("[data-testid='form-row']:nth-child(2) strong");
    $('[data-testid="POPUP"] form button').on('click',function(){
      copyToClipboard(copyElem);
      $(this).text('Copied!')
    })
    clearInterval(checkExist);
  }
}, 1000);

$( function() {
  $( ".accordion" ).accordion({
    active: false,
    collapsible: true,
    heightStyle: 'content',
    classes: {
      "ui-accordion-header":"set-arrow"
    } 
  });
});

$('#cbox').on('change',function(){
  if (this.checked) {
    $("#messageBox").show();
  } else {
    $("#messageBox").hide();
  }
});

//open cart
$(".header-align").on("click", function (e) {
  e.preventDefault();
  let cart_count = parseInt($("#cart_count").html());
  $(".mini-cart").addClass("active-cart");
  if(cart_count>0){
    $(".vertical-scroll-bar").show();
    $(".check-box").show();
    $(".checkout-btn").prop("disabled", false);
  }
  else{
    $(".vertical-scroll-bar").hide();
    $(".check-box").hide();
    $(".checkout-btn").prop("disabled", true);
  }
  $("body").css( "overflow",'hidden' );
  window.getCartInfo();
});

$(".text-cross-icon button").on("click", function (e) {
  $("body").css( "overflow",'auto' );
  $(".mini-cart").removeClass("active-cart");
});

function handleNextSlide() {
  $(".homiah-flavours-section-slider").slick("slickNext");
}
function handlePrevSlide() {
  $(".homiah-flavours-section-slider").slick("slickPrev");
}

$(document).ready(function () {

  //product-tabs
  $("#product-tabs").tabs({
    classes: {
      "ui-tab": "tab-link",
      "ui-tabs-nav": "tab-header",
      "ui-tabs-panel": "tabs-content",
    },
  });

  //mobile header
  $(".header-menu-icon").on("click", function () {
    $(".mobile").addClass("active");
    $('body').addClass("menu-open");
  });

  $(".close-mobile").on("click", function () {
    $(".mobile").removeClass("active");
    $('body').removeClass("menu-open");
  });

  $(".mobile-header-logo").on("click", function () {
    $(".mobile").removeClass("active");
    $('body').removeClass("menu-open");
  });

  //faq filters
  let checkedTag = $('[name=faq_tags]:checked').val();
  if(checkedTag){
    checkedTag = checkedTag.toLowerCase();
  }
  $(`[data-tag=${checkedTag}]`).addClass('showAccordion');
  $('[name=faq_tags]').on('change',function(){
    let checkedTag = $('[name=faq_tags]:checked').val();
    checkedTag = checkedTag.toLowerCase();
    $(`[data-tag=${checkedTag}]`).addClass('showAccordion');
    $('[data-tag]').not(`[data-tag=${checkedTag}]`).removeClass('showAccordion');
  })

  //random color generater for thumbs
  // let colors = ['#09A8AE', '#FFDA00', '#0E4B3E','#02AEB5','#FFDA00'];
  let thumbs = $('.color-thumbs .slick-dots li button').toArray();
  thumbs.forEach((elem,ind)=>{
    // let random_color = colors[Math.floor(Math.random() * colors.length)];
    if(ind % 2 == 0) {
      $(elem).css('background','#09A8AE')
    }
    else {
      $(elem).css('background','#FFDA00')
    }
  })

});

$("#product-detail-tabs").tabs({
  classes: {
    "ui-tab": "tab-link",
    "ui-tabs-nav": "tab-header",
    "ui-tabs-panel": "tabs-content",
  },
});

function increment(id) {
  document.getElementById(id).stepUp();
}
function decrement(id) {
  document.getElementById(id).stepDown();
}

function handleHomepageInput(id){
  if(document.getElementById(id).valueAsNumber <= 0 || document.getElementById(id).value == ''){
      document.getElementById(id).value = 1;
  } 
}

function handleSlider (elem){
  if(window.screen.width > 767) {
  var selectedElem = $(elem).data('slick-index');
  if(selectedElem > $('.main-div .homiah-flavours-section .homiah-flavours-section-slider .slick-current+.slick-active').data('slick-index')){
    $(".homiah-flavours-section-slider").slick('slickNext');
  }
  if(selectedElem < $('.main-div .homiah-flavours-section .homiah-flavours-section-slider .slick-current+.slick-active').data('slick-index')){
      $(".homiah-flavours-section-slider").slick('slickPrev');
  }
  setTimeout(() => {
      $('.main-div .slick-current+.slick-active .homiah-slider-images').each(function () {
        if (isScrolledIntoView(this) === true) {
          $('.main-div .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').removeClass('flavour-scroll-outview');
          $('.main-div  .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-inview');
        }
        else {
          $('.main-div .homiah-flavours-section .slick-current+.slick-active .homiah-slider-images').removeClass('flavour-scroll-inview');
          // $('.main-div .slick-current+.slick-active .homiah-slider-images').addClass('flavour-scroll-outview');
        }
    });
  }, 0);
  }
  else {
    var selectedElem = $(elem).data('slick-index');
    if(selectedElem > $('.main-div .homiah-flavours-section .homiah-flavours-section-slider .slick-current').data('slick-index')){
      $(".homiah-flavours-section-slider").slick('slickNext');
    }
    if(selectedElem < $('.main-div .homiah-flavours-section .homiah-flavours-section-slider .slick-current').data('slick-index')){
        $(".homiah-flavours-section-slider").slick('slickPrev');
    }
  }
}

function handleMobielAddon(id,addbtn){
  if($(`#${id}`).is(":checked") == false){
    $(`#${id}`)[0].checked = true
    document.getElementById(addbtn).innerHTML = 'REMOVE -';
  }
  else{
    $(`#${id}`)[0].checked = false
    document.getElementById(addbtn).innerHTML = 'ADD +';
  }
}


function toggleNavList() {
  let x = document.getElementById('myLinks'),
  y = document.getElementById('collapseIcon');
  if (x.classList.contains('d-block')) {
    x.classList.remove('d-block');
    x.classList.add('d-none');
    y.classList.remove('fa-minus');
    y.classList.add('fa-plus');
  } else if (x.classList.contains('d-none')) {
    x.classList.remove('d-none');
    x.classList.add('d-block');
    y.classList.remove('fa-plus');
    y.classList.add('fa-minus');
  }
}